export default __webpack_public_path__ + "static/media/secondary.996d66403071646baaaa06048becc35d.svg";